// extracted by mini-css-extract-plugin
module.exports = {"area1":"style_area1__SyGkV","area2":"style_area2__OiYJm","activeButton":"style_activeButton__pgpKa","fontSize":"style_fontSize__KvdzC","rounded":"style_rounded__awmI_"};